<template>
	<div class="phoneAuthentication">
		
		<div class="phone-boxs">
			<div style="line-height: 35px;">
				<span>该手机号验证码不方便获取？</span>
				<span style="color:#007AFF;cursor: pointer;" @click="changeCertType">切换至{{enterpriseCert.certType==0?'经办人模式':'法人模式' }}</span>
			</div>
			<div class="phoneAuthentication-top">
				<span>{{isLegal?'法人':'经办人' }}实名手机号认证</span>
			</div>
			<div class="phoneAuthentication-from">
				<el-form
					:model="ruleForm"
					:rules="rules"
					ref="ruleForm"
					label-position="top"
					label-width="100px"
					class="demo-ruleForm"
				>
					<div class="from-left">
						<el-form-item :label="isLegal?'法人姓名':'经办人姓名' " prop="legalName">
							<el-input v-model="ruleForm.legalName" disabled></el-input>
						</el-form-item>
						<el-form-item prop="legalPhone" :label="isLegal?'法人手机号':'经办人手机号' ">
							<div class="fPhone">
								<el-input
								:disabled="disabled || isLegal"
									v-model="ruleForm.legalPhone"
									:maxlength="11"
								></el-input>
								<el-button
                                class="base-medium-btn"
								type='primary'
									style="margin-left:15px"
									@click="getCode"
									:disabled="show"
								>
									{{ count }}
									<span v-show="show">s</span>
								</el-button>
							</div>
						</el-form-item>
						<el-tag class="tip-text">请确保为{{isLegal?'法人':'经办人' }}实名认证号码(手机号使用该身份证办理)，否则将认证失败。</el-tag>
						<el-form-item label="手机验证码" prop="code" v-if='!disabled'>
							<el-input v-model="ruleForm.code" :maxlength="6"></el-input>
						</el-form-item>
					</div>
					<div class="from-right">
						<el-form
							:model="ruleForm"
							:rules="rules"
							ref="ruleForm"
							class="demo-s"
						>
							<el-form-item :label="isLegal?'法人身份证号':'经办人身份证号' "prop="certno">
								<el-input v-model="ruleForm.certno" disabled></el-input>
							</el-form-item>
						</el-form>
					</div>
				</el-form>
			</div>
		</div>
		<nextStep
			btn1text="上一步"
			:btn2text="enterpriseCert.certPhoneFlag != 1 || count != '修改' ?'提交':'下一步' "
			btn1BgColor="white"
			btn1textColor="black"
			btn2BgColor="#1890FF"
			btn2textColor="white"
			@btn1callBack="cancel"
			@btn2callBack="handOK"
		></nextStep>
	</div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import nextStep from "@/components/nextStep/nextStep";
export default {
	data() {
		var legalPhone = (rule, value, callback) => {
			if (value === "") {
				callback(new Error("请输入手机号"));
			} else {
				// if (/[0123456789;]/g.test(value)) {
				callback();
				// } else {
				// callback(new Error('手机号格式不正确'));
			}
			// }
		};

		return {
			show: false,
			count: "获取验证码",
			timer: null,
			flowId:'',
			ruleForm: {
				legalName: "",
				legalPhone: "",
				code: "",
				certno: "",
			},
			disabled:false,
			rules: {
				code: [
					{
						required: true,
						message: "请输入验证码",
						trigger: "blur",
					},
					{
						message: "验证码长度不正确",
						trigger: "blur",
					},
				],
				legalPhone: [
					{
						required: true,
						message: "法人手机号不正确",
						trigger: "blur",
					},
					{
						validator: legalPhone,
					},
				],
			},
		};
	},
	components: {
		nextStep,
	},
	computed: {
		...mapState(["enterpriseCert"]),
		isLegal(){
			return this.enterpriseCert.certType == 0
		}
	},
	watch: {
		enterpriseCert(a, b) {
			this.initValue()
		},
	},
	created() {
		this.initValue()
	},
	methods: {
		changeCertType(){
			this.$router.push({
				name:'choseCertRoute',
				params:{
					certType:this.enterpriseCert.certType == 1?0:1
				}
			})
		},
		initValue(){
			if(this.enterpriseCert){
				if(this.enterpriseCert.certPhoneFlag == 1){
					this.disabled = true
					this.count = '修改'
                }
                console.log(this.enterpriseCert,"--------------")
				if(this.enterpriseCert.certType == 1){
					// 经办人路线   名称身份证手机号第一大步骤中已填写
					this.$set(this.ruleForm, "legalName", this.enterpriseCert.operatorName);
					this.$set(this.ruleForm, "certno", this.enterpriseCert.operatorIdnum);
					this.$set(this.ruleForm, "legalPhone", this.enterpriseCert.operatorPhone);	
					
				}else{
					this.$set(this.ruleForm, "legalName", this.enterpriseCert.legalName);
					this.$set(this.ruleForm, "certno", this.enterpriseCert.certno);
					// if(this.enterpriseCert.certPhoneFlag == 1 ){
						this.$set(this.ruleForm, "legalPhone", this.enterpriseCert.legalPhone);	
					// }
				}
				
			}
			
		},
		cancel() {
			this.$router.push('/internalSystem/certification/basicInfo')
		},
		// 手机号自动验证，验证成功到下一步基本户
		handOK() {
			// 手机号未认证，或者验证码不为空
			if(this.enterpriseCert.certPhoneFlag != 1 || this.ruleForm.code != '' ){
				if(this.flowId == ''){
					this.$message.error("请先发送验证码!")
					return 
				}
				this.$refs["ruleForm"].validate((valid) => {
					if (valid) {
						let data = {
							flowId: this.flowId,
							code: this.ruleForm.code,
							enterpriseId:this.enterpriseCert.enterpriseId,
							legalPhone:this.ruleForm.legalPhone
						};
						this.requestAPI.verifyPhoneCode(data).then((res) => {
							// 	// 确认验证码，签署协议
							let tem = this.enterpriseCert;
							tem["legalPhone"] = this.ruleForm.legalPhone;
							tem["bast64Contract"] = null;
							tem['certPhoneFlag'] = 1
							this.$store.commit("onChangeCert", tem);
							
							let data2 = this.userInfo
							data2['certPhoneFlag'] = 1
							this.$store.commit('onchangeUserInfo', data2)
							// 打款认证开关
							if(this.userInfo.ifBasicAccoFlag == 0){
								this.$router.push('/internalSystem/certification/anAgreement')
							}else{
								this.$router.push("/internalSystem/certification/accountId");
							}
						});
					}
				});
			}else{
				// 打款认证开关
				if(this.userInfo.ifBasicAccoFlag == 0){
					this.$router.push('/internalSystem/certification/anAgreement')
				}else{
					this.$router.push("/internalSystem/certification/accountId");
				}
			}
			
		},
		//获取验证码
		getCode() {
			// 60秒内不重复获取
			if(this.count == '修改'){
				this.disabled  = false
				this.count = '获取验证码'
				return 
			}
			if (this.show) {
				return;
			}
			let data = this.ruleForm;
			data["userId"] = this.userInfo.userId;
			data["enterpriseId"] = this.enterpriseCert.enterpriseId;
			data["certno"] = this.ruleForm.certno;
			data["legalName"] = this.ruleForm.legalName;

			this.requestAPI.CertLegalPhone(data).then((res) => {
				this.flowId = res.data

				const TIME_COUNT = 60;
				if (!this.timer) {
					this.count = TIME_COUNT;
					this.show = true;
					this.timer = setInterval(() => {
						if (this.count > 0 && this.count <= TIME_COUNT) {
							this.count--;
						} else {
							this.show = false;
							clearInterval(this.timer);
							this.timer = null;
							this.count = "获取验证码";
						}
					}, 1000);
				}
			});
		},
	},
};
</script>

<style lang="less" scoped>
.phoneAuthentication {
	height: 100%;
	min-height: 500px;
	background: white;
	margin: 0px 20px 0px 20px;

	.phone-boxs {
		width: 785px;
		margin: 0 auto 60px auto;
	}

	.phoneAuthentication-top {
		width: 100%;
		height: 48px;
		line-height: 48px;
		// border-left: 1px solid blue;
		// margin-top: 20px;
		border-bottom: 1px solid #ccc;

		span {
			height: 18px;
			line-height: 18px;
			border-left: 5px solid #1890FF;
			padding-left: 15px;
		}
	}

	.phoneAuthentication-from {
		margin-top: 20px;

		// display: flex;
		.demo-ruleForm {
			display: flex;

			.from-left,
			.from-right {
				width: 49%;
        margin-left: 20px;
        .tip-text{
          color: red;
          font-size: 16px;
        }
			}
		}
	}

	.fPhone {
        display: flex;
        align-items:center;
	}

	.next {
		width: 100%;

		// div {
		//   width: 100px;
		//   display: flex;
		//   margin: 0 auto;
		// }
	}

	/deep/ .el-input {
		width: 275px;
	}
}
</style>
